import './AccumulatorNew.scss'
import OutlineButton from '../Button/OutlineButton/OutlineButton';
import Label from '../Label';
import EventHandler from '../EventHandler';

const AccumulatorNew = (props: any) => {
    const {
        target,
        source,
        handleSelectLeft,
        handleSelectRight,
        handleClickRight,
        handleClickLeft,
        handleClickRightAll,
        handleClickLeftAll,
        onSearch,
        onSearchSelect,
    } = props;

    return (
        <div className='accumulator-duallist'>
            <div className='left-panel'>
                <Label data-attribute="AccumulatorNew_Default_Label">Cost Centers</Label>
                <input className='form-control search-source' placeholder='Search' onChange={onSearch}  data-attribute="AccumulatorNew_Default_Input" />
                <div data-id="source-block" className="source-block">
                    {source?.map((el: any, index: number) => {
                        return (
                            <EventHandler onEvent={() => { handleSelectLeft(el); }} data-attribute={`AccumulatorNew_${(el?.value || el?.text || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                                <p className='source-item' id={el.value}>{el.text}</p>
                            </EventHandler>
                        )
                    })}
                </div>
            </div>           
            <div className='actions'>
                <OutlineButton className='move-all-to-target' onClick={handleClickRightAll} title='Move all to selected cost centers' data-attribute="AccumulatorNew_Move_all_to_selected_cost_centers_Button" />
                <OutlineButton className='move-to-target' onClick={handleClickRight}  title='Move to selected cost centers' data-attribute="AccumulatorNew_Move_to_selected_cost_centers_Button" />
                <OutlineButton className='move-to-source' onClick={handleClickLeft}  title='Move to cost centers' data-attribute="AccumulatorNew_Move_to_cost_centers_Button" />
                <OutlineButton className='move-all-to-source'  onClick={handleClickLeftAll} title='Move all to cost centers'  data-attribute="AccumulatorNew_Move_all_to_cost_centers_Button" />
            </div>
            <div className='right-panel'>
                <Label data-attribute="AccumulatorNew_Default_Label_2">Selected Cost Centers</Label>
                <input className='form-control search-target' placeholder='Search' onChange={onSearchSelect}  data-attribute="AccumulatorNew_Default_Input_2" />
                <div data-id="target-block" className="target-block">
                    {target?.map((el: any, index: number) => {
                        return (
                            <EventHandler onEvent={() => handleSelectRight(el)} data-attribute={`AccumulatorNew_${(el?.value || el?.text || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Selected_EventHandler`}>
                                <p id={el.value} className='target-item'>{el.text}</p>
                            </EventHandler>
                        )
                    })}
                </div>
            </div>           
        </div>
    );
};

export default AccumulatorNew
